import React from 'react';
import PropTypes from 'prop-types';
import { v4 as uuidv4 } from 'uuid';
import { isEmpty as isStringEmpty } from 'front-onceforall-core/dist/utils/strings';
import { documentTypeService } from '../../../services/documentType/DocumentTypeService';
import { captureError } from '../../../utils/log';
import { DOCUMENT_CATEGORY } from '../../../utils/constant';
import ProjectDocumentsFormView from './ProjectDocumentsFormView';
import { jsx as _jsx } from "react/jsx-runtime";
function ProjectDocumentsFormContainer(props) {
  const [documentTypes, setDocumentTypes] = React.useState([]);
  const [loading, setLoading] = React.useState(true);
  const requiredDocCodes = new Set(props.documents?.map(d => d.code));
  const isOnEdit = Boolean(props.projectId);
  function handleSubmit(event) {
    event.preventDefault();
    const requiredDocumentTypes = documentTypes.filter(doc => doc.requiredInProject);
    props.onValidate(requiredDocumentTypes);
  }
  function handleCheckboxChange(doc) {
    setDocumentTypes(prevDocumentTypes => prevDocumentTypes.map(d => d.code === doc.code ? {
      ...d,
      requiredInProject: isStringEmpty(d.label) ? false : !d.requiredInProject
    } : d));
  }
  function handleAddCustom() {
    setDocumentTypes(prevDocumentTypes => [...prevDocumentTypes, {
      id: uuidv4(),
      label: '',
      category: DOCUMENT_CATEGORY.CUSTOM,
      requiredInProject: false
    }]);
  }
  function handleRemoveCustom(identifier) {
    setDocumentTypes(prevDocumentTypes => prevDocumentTypes.filter(doc => (doc.code ?? doc.id) !== identifier));
  }
  function handleChangeLabel(identifier, event) {
    const value = event.target.value;
    setDocumentTypes(prevDocumentTypes => prevDocumentTypes.map(doc => (doc.code ?? doc.id) === identifier ? {
      ...doc,
      label: value,
      requiredInProject: !isStringEmpty(value)
    } : doc));
  }
  function getDocumentTypes() {
    setLoading(true);
    const fetchDocumentTypes = isOnEdit ? documentTypeService.getDocumentTypesForProjectEdition(props.projectId) : documentTypeService.getDocumentTypesForProjectCreation();
    fetchDocumentTypes.then(docTypes => {
      const projectDocTypes = docTypes.map(doc => {
        doc.requiredInProject = requiredDocCodes.has(doc.code) || doc.category === DOCUMENT_CATEGORY.MANDATORY;
        return doc;
      });
      setDocumentTypes(projectDocTypes);
    }).catch(error => {
      if (!error.response || error.response.status !== 404) {
        captureError('Error while fetching document types', error);
      }
    }).finally(() => {
      setLoading(false);
    });
  }
  React.useEffect(() => {
    getDocumentTypes();
  }, []);
  return /*#__PURE__*/_jsx(ProjectDocumentsFormView, {
    onSubmit: handleSubmit,
    onChangeLabel: handleChangeLabel,
    onRemoveCustom: handleRemoveCustom,
    onCheckboxChange: handleCheckboxChange,
    onAddCustom: handleAddCustom,
    displayEditMessage: props.displayEditMessage,
    isOnEdit: isOnEdit,
    loading: loading,
    documentTypes: documentTypes
  });
}
ProjectDocumentsFormContainer.defaultProps = {
  displayEditMessage: false,
  documents: []
};
ProjectDocumentsFormContainer.propTypes = {
  documents: PropTypes.arrayOf(PropTypes.shape({
    code: PropTypes.string.isRequired
  })),
  onValidate: PropTypes.func.isRequired,
  displayEditMessage: PropTypes.bool,
  projectId: PropTypes.number
};
export default ProjectDocumentsFormContainer;